import { Table, type TableColumn } from "src/ui/table/table";
import {
  PINNED,
  WIDTHS,
} from "src/pages/ad-studio/insights/performance/view/constants";
import type { ColumnState } from "src/pages/ad-studio/insights/performance/view/types";
import { TableFrame } from "src/pages/ad-studio/insights/performance/view/table-frame";

const toSkeletonColumn = (
  column: ColumnState,
): TableColumn<Record<string, unknown>> => {
  const width = WIDTHS[column.width];
  return {
    name: column.label,
    min: width.min,
    ...(width.max === "no-max" ? {} : { max: width.max }),
    ...(column.pinned === "pinned-left"
      ? { headerSx: { ...PINNED, zIndex: 2 }, cellSx: { ...PINNED, zIndex: 1 } }
      : {}),
    cell: () => null,
  };
};

type PerformanceTableSkeletonProps = { columns: readonly ColumnState[] };

export const PerformanceTableSkeleton = ({
  columns,
}: PerformanceTableSkeletonProps) => (
  <TableFrame>
    <Table<Record<string, unknown>>
      columns={columns.map(toSkeletonColumn)}
      data={[]}
      primaryKey="id"
      loading
      scrollableX
      defaultMin="min-content"
    />
  </TableFrame>
);
